// Several ng geenerates over the life-time of the app development:
//
// For example:
//
//  ref: npm install --save @angular/material @angular/cdk @angular/animations   
//

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router'
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FooterLayoutComponent } from './layout/footer-layout/footer-layout.component';
import { HeaderLayoutComponent } from './layout/header-layout/header-layout.component';
import { MessagesLayoutComponent } from './layout/messages-layout/messages-layout.component';
import { AdsenseLayoutComponent } from './layout/adsense-layout/adsense-layout.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
  declarations: [MainLayoutComponent, FooterLayoutComponent, HeaderLayoutComponent, MessagesLayoutComponent, AdsenseLayoutComponent],
  imports: [
    // vendor
    BrowserModule,
    BrowserAnimationsModule,

    // material
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    RouterModule
  ],
  exports: [MainLayoutComponent, HeaderLayoutComponent, FooterLayoutComponent, MessagesLayoutComponent, AdsenseLayoutComponent]
})
export class CoreModule { }
